import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  FetchInitialImportDocumentValuesActionType,
  FETCH_INITIAL_IMPORT_DOCUMENT_VALUES_SUCCESS,
  FETCH_INITIAL_IMPORT_DOCUMENT_VALUES_FAILURE,
  FETCH_INITIAL_IMPORT_DOCUMENT_VALUES
} from 'src/redux/importDocumentReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchImportDocumentInitialValuesFlow(
  action: FetchInitialImportDocumentValuesActionType
): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/import_documents/${action.payload.id}/initial_form_values`
    const response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(FETCH_INITIAL_IMPORT_DOCUMENT_VALUES_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_INITIAL_IMPORT_DOCUMENT_VALUES_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchImportDocumentInitialValues(): Generator<any, void, any> {
  yield takeLatest(FETCH_INITIAL_IMPORT_DOCUMENT_VALUES, FetchImportDocumentInitialValuesFlow)
}
